<template>
    <div class="row mr-1 d-flex align-items-center">
        <div class="text-muted mr-1">ต้องการสร้างพัสดุจำนวนมากใช่ไหม ?</div>
        <ImportExcel @onSuccess="onUpload">
            <template v-slot:header>
                <div class="tooltip-container">
                    <button
                        class="btn btn-primary excel-download-button"
                        :disabled="isCod && !isCodAgreementAgreed"
                    >
                        สร้างพัสดุแบบอัพโหลด
                    </button>
                    <span v-if="isCod && !isCodAgreementAgreed" class="tooltip-text">กรุณายอมรับเงื่อนไขการให้บริการ COD</span>
                </div>
            </template>
        </ImportExcel>
        <div class="ml-1 mb-1 d-flex align-items-center">
            <div class="tooltip-container">
                <i class="fa fa-info-circle fa-xs mr-1"></i>
                <span class="tooltip-text">การอัพโหลดคือการสร้างหลายๆพัสดุพร้อมกัน โดยใช้ Excel</span>
            </div>
            <div
                class="tooltip-container text-primary cursor-pointer"
                @click="downloadShipmentExcelTemplate()"
            >
                ตัวอย่างไฟล์คลิกที่นี่
                <span class="tooltip-text">คลิกเพื่อดาวน์โหลดไฟล์ตัวอย่าง</span>
            </div>
        </div>
    </div>
</template>

<script>
import ImportExcel from '@/components/custom/pos/ImportExcel';

const ERROR_MSG = {
    invaid_format: 'กรุณากรอกข้อมูลตาม รูปแบบที่กำหนด',
    invaid_length: 'กรุณาสร้างรายการทีละ 50 รายการ'
};

const TYPR_ERROR_MSG = ['UPLOAD_EXCEL'];

export default {
    name: 'CreateOrderByExcel',
    props: {
        courierKey: String,
        isCod: {
            type: Boolean,
            default: false
        },
        isCodAgreementAgreed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            json: [],
            error: []
        };
    },
    components: {
        ImportExcel
    },
    methods: {
        downloadShipmentExcelTemplate() {
            let fileName = 'format_import_excel_cod';

            if (this.courierKey === 'SCG') {
                fileName = 'format_import_excel_cod_SCG';
            } else if (['SCGC', 'SCGF'].includes(this.courierKey)) {
                fileName = 'format_import_excel_cod_SCGC-SCGF';
            }

            if (this.$THEME.name === 'quickexpress') {
                fileName = fileName + '_QUICK';
            }

            window.open(`download/${fileName}.xlsx?v=` + process.env.VUE_APP_VERSION, '_blank');
        },
        onUpload(e) {
            if (e.status === true && e.data.length > 0 && this.countColumn(e.data) && this.countRow(e.data)) {
                this.json = e.data;
                this.responseSuccess(this.json);
            } else {
                let typeError = '';
                let msgError = '';
                if (!this.countRow(e.data)) {
                    typeError = 'invaid_length';
                    msgError = ERROR_MSG.invaid_length;
                } else {
                    typeError = Object.keys(ERROR_MSG)[0];
                    msgError = ERROR_MSG.invaid_format;
                }
                this.error.push({
                    type: typeError,
                    msg: msgError
                });
                this.responseError(TYPR_ERROR_MSG[0]);
            }
        },
        countColumn(data) {
            return data.every((col) => {
                return Object.keys(col).length > 11;
            });
        },
        countRow(data) {
            return data.length <= (this.$THEME.maxImportShipment || 50);
        },
        responseSuccess(data) {
            return this.$emit('onSuccess', this.convertResponseSuccess(data));
        },
        responseError(type) {
            return this.$emit('onError', this.convertResponseError(type, this.error));
        },
        convertResponseSuccess(data) {
            return {
                status: true,
                data: data
            };
        },
        convertResponseError(type, data) {
            return {
                status: false,
                type: type,
                error: data
            };
        }
    }
};
</script>

<style scoped>
.tooltip-container {
    position: relative;
    display: inline-block;
}

.tooltip-container .tooltip-text {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 5px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%; /* Position above the element */
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.2s;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>
